export const SHOW_HIDE_TOAST = "SHOW_HIDE_TOAST";
export const UNREAD_NOTIFICATIONS = "UNREAD_NOTIFICATIONS";
export const ALL_NOTIFICATIONS = "ALL_NOTIFICATIONS";
